<script setup>
import EcosystemsAccessSettings from "@/components/trackers/EcosystemsAccessSettings.vue";
import {ref, computed, inject, watch} from "vue";
import {trackerAccess} from "../../../helpers/string";
import {trackerTypes} from "@/constants/trackers";
import {useStore} from "vue2-helpers/vuex";

const store = useStore();
const tracker = inject('tracker');
const enableEcosystemSharing = ref(false);
const canChangeVisibility = computed(() => tracker.userPermissions.includes('tracker-add-ecosystem'));
const accessSettingsModal = ref(null);

watch(() => tracker.accessType, (value) => {
    enableEcosystemSharing.value = value !== 'private';
}, {immediate: true});

function setSharing() {
    if (enableEcosystemSharing.value) {
        showAccessSettingsModal();
    } else {
        tracker.accessType = trackerTypes.PRIVATE;
        tracker.ecosystems = [];
    }
}

function showAccessSettingsModal() {
    accessSettingsModal.value.open(tracker.accessType, tracker.ecosystems);
}

function accessSettingsChanged({accessType, ecosystems}) {
    tracker.accessType = accessType;
    tracker.ecosystems = ecosystems;
}

function accessSettingsCancelled() {
    if (tracker.accessType === 'private') {
        enableEcosystemSharing.value = false;
    }
}
</script>

<template>
    <div v-if="store.getters.isEnterprise && !store.getters.isEventLimited && !store.getters.onlyNeeds && tracker.type === trackerTypes.PRIVATE && (enableEcosystemSharing || canChangeVisibility)">
        <h5 class="heading5 heading5--secondary mb-2">Ecosystem Sharing</h5>

        <div class="form__item">
            <div class="input-checkbox mb-4">
                <input
                    v-model="enableEcosystemSharing"
                    id="enable-ecosystem-sharing"
                    type="checkbox"
                    :disabled="!canChangeVisibility"
                    @change="setSharing"
                >
                <label for="enable-ecosystem-sharing">Enable ecosystem sharing</label>
            </div>

            <div class="shared-ecosystem-label" v-if="tracker.accessType !== trackerTypes.PRIVATE && canChangeVisibility">
                <p style="line-height: normal" class="modal-text"> {{trackerAccess(tracker)}} <a class="heading-edit" @click="showAccessSettingsModal"></a></p>
            </div>
        </div>

        <EcosystemsAccessSettings
            v-if="canChangeVisibility"
            ref="accessSettingsModal"
            @saved="accessSettingsChanged"
            @cancelled="accessSettingsCancelled"
        />
    </div>
</template>

<style scoped>

</style>
